import PrimusWorker from './PrimusWorkerWrapper';

export default PrimusWorker;